import {
    ApplicationConfig,
    importProvidersFrom,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { APP_BASE_HREF } from '@angular/common';
import { Interceptor } from './core/services/interceptor.service';
import { PortalsResolveService } from './core/services/portals.resolve.service';
import { PortalService } from './core/services/portal.service';
import { PersonalDataRequestService } from './core/services/personal-data-request.service';
import { AuthenticationService } from './core/services/authentication.service';
import { CookieModule } from 'ngx-cookie';
import packageJson from 'package.json';

export function HttpLoaderFactory(httpBackend: HttpBackend) {
    return new MultiTranslateHttpLoader(httpBackend, [
        { prefix: '/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-tools/assets/i18n/', suffix: '.json?' + packageJson.version },
    ]);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpBackend],
                },
            }),
            SimpleNotificationsModule.forRoot({
                position: ['bottom', 'right'],
                timeOut: 5000,
                lastOnBottom: true,
                showProgressBar: true,
                pauseOnHover: true,
            }),
            CookieModule.forRoot(),
        ),
        {
            provide: APP_BASE_HREF,
            useValue: '/',
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Interceptor,
            multi: true,
        },
        PortalService,
        PersonalDataRequestService,
        PortalsResolveService,
        AuthenticationService,
    ],
};
